module.exports = __webpack_public_path__ + "img/logo-icone-20.c6108af1.svg";